module.exports = __webpack_public_path__ + "img/list.7da6f7a2.svg";